export default {
  USER: "/user",
  NOTIFICATION: "/user/notification",
  AUTH: "/auth",
  USERSETTING: "/user/setting",
  USERSETTINGCONFIRM: "/user/setting/confirm",
  EMAILSETTING: "/user/email",
  EMAILCHANGECOMPLETE: "/user/email/change/:mail_id",
  PASSWORDSETTING: "/user/password",
  USERGUEST: "/user/guest",
  LOGOUT: "/user/logout",
  WITHDRAWAL: "/user/withdrawal",
  WITHDRAWALCONFIRM: "/user/withdrawal/confirm",
  WITHDRAWALFINISH: "/user/withdrawal/finish",
  PASSWORDREMIND: "/user/guest/password_remind",
  PASSWORDRESET: "/user/guest/password_reset/check/:id",
  LOGINERROR: "/user/guest/login/error",
  REGISTER_GUEST_MAIL_RESEND: "/user/guest/register_mail_resend",
  SERVICE: "/user/services",
  VERIFY_EMAIL: "/user/verify_email",
  DOWNLOADPDF: "/user/download_pdf",
  SURVEY: "/user/survey",
  SURVEYERR: "/user/survey/error",
  SURVEY_MEMBER: "/survey/member",
  VERIFY_EMAIL_FINISH: "/user/email/finish",
  Events: "/user/events",
  SURVEY_ANSWER: "/user/survey/answer/:survey_web_url_id",
  SURVEY_ANSWER_CONFIRM: "/user/survey/answer/:survey_web_url_id/confirm",
  SURVEY_ANSWER_FINISH: "/user/survey/answer/finish",
  REGISTER: "/user/guest/register",
  REGISTERSIMPLE: "/user/guest/register_simple",
  CONFIRM_REGISTER: "/user/guest/register/confirm",
  EMAIL_SENT: "/user/guest/register/email_sent",
  COMPLETED: "/user/guest/register/completed",
  LOGIN: "/user/guest",
  PASSWORD_LOGIN: "/auth/password_login",
  AUTH_LOGIN: "/auth/auth/login",
  RESET_PASS: "/reset-password",
  RESET_PASS_COMPLETED: "/reset-password-completed",
  OPTOUTNOTIFICATION: "/user/opt-out-notification",
  EMAIL_CHANGE: "/email/change",
  SESSION_VIDEO: "/user/events/ondemand_viewer/:session_id",
  CONFIRMERROR: "/user/email_sent/failed",
  CONFIRMSUCCESS: "/user/email_sent/success",
  CREATEUSERERROR: "/user/guest/register_simple/error",
  MASSMEDIAN: "/user/massmedian",
  CLIPPING: "/user/clipping",
};
